import React from 'react';
import classNames from 'classnames';
import ResponsiveImage from '../responsive-image';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const MoviePoster = ({
  className,
  image
}) => /*#__PURE__*/_jsx("div", {
  className: classNames(style.MoviePoster, className),
  "data-test-id": "movie-image",
  children: /*#__PURE__*/_jsx(ResponsiveImage, {
    mobileRatio: "standard",
    desktopRatio: "standard",
    desktopImageUrl: image,
    mobileImageUrl: image
  })
});

export default MoviePoster;